import OrganizationChartV2 from './OrganizationChartV2';

export default OrganizationChartV2;
